<template>
    <currency-input
            v-model="content"
            @input="handleInput"
            @change = 'handleChange'
            :currency = "{prefix: '', suffix: '%'}"
            locale = 'en'
            class = 'appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5'
    />
</template>

<script>
    import {CurrencyInput} from 'vue-currency-input'
    export default {
        name: 'BasePercent',
        components: {CurrencyInput},
        props: ['value'],
        data() {
            return {
                content: this.value,
            }
        },
        methods: {
            handleChange() {
                this.$emit('change', this.content);
            },
            handleInput() {
                this.$emit('input', this.content);
            }
        },
        watch: {
            value: {
                immediate: true,
                handler(val) {
                    this.content = val;
                }
            }
        },
    }
</script>